
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'CancelSCAPlan',
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  }
})
